import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import team from '@/components/team'
import cooperation from '@/components/cooperation'
import applications from '@/components/applications'
import detail from '@/components/detail'
import teaching from '@/components/teaching'
import founder from '@/components/founder'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(Router)
Vue.use(ElementUI)
export const bus = new Vue()
const routes = [
  {
    path: '/',
    name: '首页',
    component: index,
    children: [],
    index: 0
  },
  {
    path: '/team',
    name: '核心团队',
    component: team,
    children: [],
    index: 1
  },
  {
    path: '/applications',
    name: '应用案例',
    component: applications,
    children: [],
    index: 2
  },
  {
    path: '/cooperation',
    name: '合作模式',
    component: cooperation,
    children: [],
    index: 3
  },
  {
    path: '/detail',
    name: '简介',
    component: detail,
    children: [],
    index: 4
  },
  {
    path: '/teaching',
    name: '教学成果',
    component: teaching,
    children: [],
    index: 5
  }, // 2023.2新增
  {
    path: '/founder',
    name: '创始人介绍',
    component: founder,
    children: [],
    index: 6
  } // 2023.9新增
]
const router = new Router({
  routes
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js